import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExhibitorsProjectType } from "../../../types/ScientificModule";

const initialState: ExhibitorsProjectType = {
    id: "",
    idExhibitor: "",
    idProject: "",
    status: false,
    position: ""
};

const exhibitorsProjectsSlice = createSlice({
    name: "exhibitorsProjects",
    initialState,
    reducers: {
        setExhibitorsProjectsData: (state, action: PayloadAction<ExhibitorsProjectType>) => ({ ...state, ...action.payload }),
        resetExhibitorsProjectsData: () => ({ ...initialState }),
    },
});

export const { setExhibitorsProjectsData, resetExhibitorsProjectsData } = exhibitorsProjectsSlice.actions;

export default exhibitorsProjectsSlice.reducer;
